import React from "react";
import { DatePicker, Select, Tooltip } from "antd";
import dayjs from "dayjs";
import ReportButton from "@controls/report-button";
import { REPORT_VID } from "@components/service/reports/report-types";
import { DATE_MODE_OPTIONS } from "./doc-exp-utils";
import DocExpsActionsCombo from "./doc-exps-actions-combo";
import DocExpsComboFilter from "./doc-exps-combo-filter";
import chevronSrc from "./assets/chevron-down.svg";
import plusSrc from "./assets/plus.svg";

const toDayjs = (value) => {
  if (!value) return null;
  const d = dayjs(value);
  return d.isValid() ? d : null;
};

const Chevron = () => (
  <span className="doc-exps__chevron">
    <img src={chevronSrc} alt="" />
  </span>
);

/**
 * Фильтры и тулбар журнала путёвок.
 */
const DocExpsFilters = ({
  value,
  branches,
  vidPutevki,
  loading,
  canAdd,
  canDelete,
  canConfirm,
  canUnconfirm,
  canCheckIn,
  canUncheckIn,
  canCheckOut,
  canUncheckOut,
  canCancel,
  canBook,
  canClearPlacement,
  canRecalculate,
  canChangeNumber,
  canMovePlacement,
  recalculateBlockReason,
  reportIds,
  onChange,
  onRefresh,
  onCreate,
  onDelete,
  onConfirm,
  onUnconfirm,
  onCheckIn,
  onUncheckIn,
  onCheckOut,
  onUncheckOut,
  onCancelDoc,
  onBook,
  onClearPlacement,
  onRecalculate,
  onChangeNumber,
  onMovePlacement
}) => {
  const patch = (next) => onChange({ ...value, ...next });

  return (
    <div className="doc-exps__filters">
      <div className="doc-exps__filters-row">
        <Tooltip title={canAdd ? "Новая путёвка" : "Нет права на продажу + бронь"}>
          <button
            type="button"
            className="doc-exps__add-icon-btn"
            disabled={!canAdd || loading}
            aria-label="Новая путёвка"
            onClick={onCreate}
          >
            <span className="doc-exps__add-icon">
              <img src={plusSrc} alt="" />
            </span>
          </button>
        </Tooltip>
        <div className="doc-exps__field doc-exps__field--mode">
          <span className="doc-exps__mode-sizer" aria-hidden="true">
            {DATE_MODE_OPTIONS.map((opt) => (
              <span key={opt.value}>{opt.label}</span>
            ))}
          </span>
          <Select
            value={value.dateMode}
            options={DATE_MODE_OPTIONS}
            suffixIcon={<Chevron />}
            popupMatchSelectWidth={false}
            title="Вид периода"
            aria-label="Вид периода"
            onChange={(dateMode) => patch({ dateMode })}
          />
        </div>
        <div className="doc-exps__field doc-exps__field--date">
          <span className="doc-exps__date-sizer" aria-hidden="true">
            {toDayjs(value.dateBeg)?.format("DD.MM.YYYY") || "00.00.0000"}
          </span>
          <DatePicker
            allowClear={false}
            format="DD.MM.YYYY"
            value={toDayjs(value.dateBeg)}
            suffixIcon={null}
            title="Дата с"
            aria-label="Дата с"
            onChange={(d) => patch({ dateBeg: d ? d.format("YYYY-MM-DD") : value.dateBeg })}
          />
        </div>
        <div className="doc-exps__field doc-exps__field--date">
          <span className="doc-exps__date-sizer" aria-hidden="true">
            {toDayjs(value.dateEnd)?.format("DD.MM.YYYY") || "00.00.0000"}
          </span>
          <DatePicker
            allowClear={false}
            format="DD.MM.YYYY"
            value={toDayjs(value.dateEnd)}
            suffixIcon={null}
            title="Дата по"
            aria-label="Дата по"
            onChange={(d) => patch({ dateEnd: d ? d.format("YYYY-MM-DD") : value.dateEnd })}
          />
        </div>
        <DocExpsActionsCombo
          canCheckIn={canCheckIn}
          canCheckOut={canCheckOut}
          canConfirm={canConfirm}
          canDelete={canDelete}
          canUnconfirm={canUnconfirm}
          canUncheckIn={canUncheckIn}
          canUncheckOut={canUncheckOut}
          canCancel={canCancel}
          canBook={canBook}
          canClearPlacement={canClearPlacement}
          canRecalculate={canRecalculate}
          canChangeNumber={canChangeNumber}
          canMovePlacement={canMovePlacement}
          canRefresh={!loading}
          recalculateBlockReason={recalculateBlockReason}
          onCheckIn={onCheckIn}
          onCheckOut={onCheckOut}
          onConfirm={onConfirm}
          onDelete={onDelete}
          onUnconfirm={onUnconfirm}
          onUncheckIn={onUncheckIn}
          onUncheckOut={onUncheckOut}
          onCancelDoc={onCancelDoc}
          onBook={onBook}
          onClearPlacement={onClearPlacement}
          onRecalculate={onRecalculate}
          onChangeNumber={onChangeNumber}
          onMovePlacement={onMovePlacement}
          onRefresh={onRefresh}
        />
        <div className="doc-exps__extra-actions">
          <ReportButton
            vid={REPORT_VID.TRAVEL}
            ids={reportIds}
            begPer={value.dateBeg}
            endPer={value.dateEnd}
            disabled={!reportIds?.length}
            compact
          />
        </div>
        <div className="doc-exps__field doc-exps__field--combo">
          <DocExpsComboFilter
            value={value}
            branches={branches}
            vidPutevki={vidPutevki}
            onChange={patch}
          />
        </div>
      </div>
    </div>
  );
};

export default DocExpsFilters;
